import { render, staticRenderFns } from "./dispatcher-dialog-form.vue?vue&type=template&id=5d6ed98e&scoped=true"
import script from "./dispatcher-dialog-form.vue?vue&type=script&lang=js"
export * from "./dispatcher-dialog-form.vue?vue&type=script&lang=js"
import style0 from "./dispatcher-dialog-form.vue?vue&type=style&index=0&id=5d6ed98e&prod&scoped=true&lang=css"
import style1 from "./dispatcher-dialog-form.vue?vue&type=style&index=1&id=5d6ed98e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d6ed98e",
  null
  
)

export default component.exports